module.exports = __webpack_public_path__ + "img/zuurstok-header.224bd958.png";